import { Navigate, Outlet } from 'react-router-dom'
import {
  HilabsStack as Stack,
  HilabsContainer as Container,
  HilabsGrid as Grid,
} from '@hilabs-react-ui-components/core'

import { StyledBox, StyledGridComponent } from './styles'
import BackgroundImage from '../../assets/illustrations/login_bg.png'
import AppLogo from '../../assets/icons/auth/HiLabs_Primary_RGB.svg'
import { CheckToeknExpiry, PREV_PATH } from '../../constant/auth'

export default function AuthLayout() {
  const isExpired =  CheckToeknExpiry()
  const path = PREV_PATH() || '/dashboard/app'
  if(!isExpired)
  return <Navigate to={path} />
  return (
    <StyledBox
      className="auth-layout-wrapper"
      sx={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#f5f5f5',
        backgroundPosition: '100% bottom',
      }}
    >
      <Container maxWidth="xl">
        <StyledGridComponent
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} md={4}>
            <Stack mb={4} direction="row" justifyContent="center">
              <img src={AppLogo} alt="app-Logo" width={120} />
            </Stack>
            <Outlet />
          </Grid>
        </StyledGridComponent>
      </Container>
    </StyledBox>
  )
}
